import React from 'react'
import {
    List,
    Edit,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
} from 'react-admin'

export const commonCurrencyList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="code" />
                <TextField source="name" />
                <TextField source="symbol" />
            </Datagrid>
        </List>
    )
}
